import React, { useState, useCallback } from 'react';
import './delete-catalogue.scss';
import {
  IconButton,
} from '@material-ui/core';
import { DeleteOutlinedIcon } from 'components/icons/delete-outlined';
import { ConfirmationDialog } from 'components/confirmation-dialog/confirmation-dialog';
import { DeleteCatalogueProps } from './delete-catalogue-props';

export const DeleteCatalogue: React.FC<DeleteCatalogueProps> = (props) => {
  const {
    id,
    type,
    onDelete,
  } = props;

  const [open, setOpen] = useState(false);
  const cancel = useCallback(() => setOpen(false), []);
  const deleteCatalogue = () => {
    setOpen(false);
    onDelete(id, type);
  };

  return (
    <div className="sg-delete-catalogue">
      <IconButton color="secondary" onClick={() => setOpen(true)}>
        <DeleteOutlinedIcon color="primary" />
      </IconButton>
      <ConfirmationDialog
        confirmLabel="Yes, delete"
        cancelLabel="No, cancel"
        title="Delete file"
        onCancel={cancel}
        onConfirm={deleteCatalogue}
        open={open}
      >
        This will also delete any published listings. <br /><br /> Do you want to delete?
      </ConfirmationDialog>
    </div>
  );
};
